import { AppSet } from '../context/StudioContext';

/**
 * Formats the display name for an app set by removing "Production" from the production app name
 * @param appSet - The app set to format
 * @returns The formatted display name
 */
export const formatAppSetDisplayName = (appSet: AppSet): string => {
  const productionName = appSet.productionApp.displayName;
  // Remove "Production" from the end of the name if it exists
  return productionName.replace(/\s*Production\s*$/i, '');
}; 